import { render, staticRenderFns } from "./BaseRealNameModify.vue?vue&type=template&id=4028d358&scoped=true&"
import script from "./BaseRealNameModify.vue?vue&type=script&lang=js&"
export * from "./BaseRealNameModify.vue?vue&type=script&lang=js&"
import style0 from "./BaseRealNameModify.vue?vue&type=style&index=0&id=4028d358&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4028d358",
  null
  
)

export default component.exports